import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

interface MyCafeteriaVbkApplicationTableHeaderProps {
  isMobile: boolean;
}

export const MyCafeteriaVbkApplicationTableHeader = ({
  isMobile,
}: MyCafeteriaVbkApplicationTableHeaderProps) => {
  const { t } = useTranslation();
  const columnWidth = "156px";
  return (
    <Box
      width={isMobile ? "max-content" : "auto"}
      height="48px"
      paddingLeft="8px"
      display="flex"
      flexDirection="row"
      alignItems="center"
      style={{ borderBottom: "2px solid #5E6366" }}
    >
      <Box flexGrow={1} textAlign="left" padding="0px 8px" minWidth="180px">
        <Typography variant="body1">{t("MY_CAFETERIA_BENEFIT")}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body1">{t("MY_CAFETERIA_MONTHS")}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body1">{t("MY_CAFETERIA_NUMBER_OF_MONTHS")}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body1">{t("MY_CAFETERIA_NETTO")}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant={"body1"}>{t("OC_COST")}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body1">{t("MY_CAFETERIA_BRUTTO")}</Typography>
      </Box>
    </Box>
  );
};

export default MyCafeteriaVbkApplicationTableHeader;
